module.exports = __webpack_public_path__ + "e9cd46f245ce50073f4160fd6f000381.svg";